
import { aiFundamentalsArticles } from './mock-data/ai-fundamentals';
import { businessArticles } from './mock-data/business';
import { ethicsArticles } from './mock-data/ethics';
import { technicalArticles } from './mock-data/technical';
import { otherArticles } from './mock-data/other-articles';

// Combine all categories of articles
export const mockArticles = [
  ...aiFundamentalsArticles,
  ...businessArticles,
  ...ethicsArticles,
  ...technicalArticles,
  ...otherArticles
];

export default mockArticles;
